<template lang="pug">
  v-row(no-gutters style="padding-bottom: 10a0px; padding-top: 12px;" :class="{'bg-color-unset': isThaiCharoenPlus}").v-layout1
    v-col(cols=12).mb-5
      head-member
        banner   
    v-col(cols=12)
      main-content-extra(v-if="isExtraLayout")
      main-content(v-else)
    //- v-col(cols=12 class="banner").pa-3
    //-   banner
    v-col(cols=12)
      lotto-result
    dialog-alert(ref='newsalert')
</template>
<script>     
import { banners as apiBanner } from '@/apis'  
import { ROUTE_DEPOSIT, ROUTE_WITHDRAW } from '@/const/route'
import dialogAlert from '@/components/Dialog/DialogIndexAlert.vue'  
import dialogRoulete from '@/components/Dialog/DialogRoulete'
import HeadMember from "@/components/AppBar/HeadMember";
import ExternalGameTab from './child/ExternalGameTab'
import MainContent from './child/MainContent'
import MainContentExtra from './child/MainContentExtra'
import Banner from './child/Banner'
import LottoResult from './child/LottoResult'
export default {  
  components : {
    dialogAlert,
    dialogRoulete,
    ExternalGameTab,
    HeadMember,
    MainContent,
    MainContentExtra,
    Banner,
    LottoResult,
  },

  data: () => ({
    bannerUrl : [],
    innerWidth: window.innerWidth
  }), 
  computed : { 
    ROUTE_DEPOSIT: () => ROUTE_DEPOSIT,
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    isMobile () {
      return this.innerWidth < 640
    },
    isExtraLayout () {
      return this.isDefaultSite || this.isChokCharoen || this.isBooncharern || this.isSapcharern || this.isPacharern
    }
  },   

  async mounted () {     
    await this.getBanner ();

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    // this.$nextTick(()=>this.$refs.dialogroulete.open())
  },   
  
  methods: {  
    imageIcon (id) {
      try{
        return require(`@/assets/index/v2/${id}.svg`)} 
      catch {
        return require(`@/assets/anything/image-placeholder.svg`)
      } 
    },
    async getBanner () { 
      const [err,data,] =  await apiBanner.get({ type_id: 1 })
      
      if(err) {
        return
      }
      this.bannerUrl = data 
    }, 

    goToWithdraw () {
      this.GA('Withdraw','')
      this.$router.push({
        name: ROUTE_WITHDRAW
      })
    },

    goToDeposit () {
      this.GA('Deposit','')
      this.$router.push({
        name: ROUTE_DEPOSIT
      })
    },

    GA (action,name){
      this.$ga.event('Button', action, 'IndexPage-V2', name)
    },
    onResize () {
      this.innerWidth = window.innerWidth
    },
  }
}
</script>
<style scoped>
.v-layout1 {
  background-color: var(--v3-sec-color-20);
}

@media only screen and (max-width: 640px) {
  .v-layout1 {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>